import React, { useEffect, useRef, useState } from "react";
import { FlatList, ActivityIndicator, Pressable, ScrollView, StyleSheet, Switch, Text, TextInput as ReactText, TouchableOpacity, View, Alert, NativeSyntheticEvent, TextInputKeyPressEventData } from "react-native";
import { MyButton, TextInputTemp } from "./buttonsAndControls";
import { Checkbox, IconButton, Modal, Portal, TextInput, Provider as PaperProvider } from "react-native-paper";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { header, profileName, stopCodes } from "./StockAwareTempData";
import DateModule from "./mainAppDateModule";
import createAndSavePDF from "./pdfCreate";

const darkColour='#2a2d3e';

interface ChildViewData {
  id: number;
  texts: string[];
}

interface SalesRecord {
  ID: number;
  Customer_Name: string;
  Sales_Person: string;
  Phone_Number: string;
  Date: string;
  Payment_Method: string;
  Total: number;
  Discount: number;
  After_Discount: number;
  Sales_ID: string;
}

interface SellList {
  ID: number;
  Quantity: number;
  Board: string;
  Customer: string;
  Payment_Method: string;
	Notes: string;
  Delivered: string;
	Item_Price: number;
  Total: number;
}


const ToBeSold = ({ texts, delPressed, isChecked, onCheckboxChange, index, }
  : ChildViewData & { delPressed: () => void, isChecked: boolean; onCheckboxChange: (value: boolean) => void; index: number; }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
	const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
  const sizes: number[] = [57, 290, 300, 100, 150];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
			<Pressable style={{...stylesBox.purchasedTouchable,  
          backgroundColor: hovered ? '#CCCCCC' : 'transparent', 
          opacity: isOpacity ? 0.2 : 1 }}
        onHoverIn={() => setHovered(true)}
        onHoverOut={() => setHovered(false)}
        onPressIn={() => setIsOpacity(true)}
        onPressOut={() => setIsOpacity(false)}
			>
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.viewStyle, width: sizes[i] }} >
            <Text key={i} style={stylesBox.textStyle}>
              {text}
            </Text>
          </View>
        ))}
        <View style ={{width:38, height:35, borderWidth:0, borderRightWidth:2, borderColor:'black', }}>
          <Checkbox
            status={isChecked ? 'checked' : 'unchecked'}
            onPress={() => onCheckboxChange(!isChecked)}
            color= {darkColour}
            disabled={true}
          />
        </View>
				{hovered &&
          <IconButton icon={'trash-can-outline'} size={25} focusable={false} iconColor={darkColour}  
          style={stylesBox.iconButtonStyle}
          onPress={() => delPressed()}
				/>
				}
				</Pressable>
      </TouchableOpacity>
    </View>
  );
};

const ChildView = ({ texts, isChecked, onPressed, index, delPressed,
}: ChildViewData & { isChecked: boolean; onPressed: () => void;
  index: number; delPressed: (()=> void); }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
  const sizes: number[] = [180, 158, 108 , 105 ];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
				<Pressable style={{... stylesBox.childPressable, backgroundColor: isChecked 
						? darkColour : hovered ? '#CCCCCC' : 'transparent', opacity: isOpacity ? 0.2 : 1}}
					onPress={() => {onPressed();}}
					onHoverIn={() => setHovered(true)}
					onHoverOut={() => setHovered(false)}
					onPressIn={() => setIsOpacity(true)}
					onPressOut={() => setIsOpacity(false)}
				>
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.viewStyle, width: sizes[i] }}>
            <Text key={i} style={{...stylesBox.textStyle, color: isChecked ? 'white' : darkColour }}>
              {text}
            </Text>
          </View>
        ))}
        {hovered &&
					<IconButton icon={'trash-can-outline'}size={25} focusable={false} iconColor={isChecked ? 'white' : darkColour}  
					style={{justifyContent:'center', padding:0, margin:0, marginLeft: -5, alignContent:'center'}}
					onPress={() => delPressed()} />
				}

				</Pressable>
      </TouchableOpacity>
    </View>
  );
};

const SalesPerCustomer = () => {
  header('Sales record view per customer');
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [searchText, setSearchText] = useState('');
	const [filteredResult, setFilteredResult] = useState<SalesRecord[]>([]);
	const [sales, setSales] = useState<SalesRecord[]>([]);
	const [sellItems, setSellItems] = useState<SellList[]>([]);
  const [oneOnly, setOneOnly] = useState('');
  const [totalDue, setTotalDue] = useState(' ');
  const [whoClicked, setWhoClicked] = useState('today')
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(true);
  const [totalRows, setTotalRows] = useState(-1);
  const [salesID, setSalesID] = useState('');
  const [dateVisible, setDateVisible] = useState(false);
  let timeout: NodeJS.Timeout;
  const [grossTotal, setGrossTotal] = useState(' ');
  const [customDate, setCustomDate] = useState(false);
  const [footerText, setFooterText] = useState('Showing from today');
  const stocksArray: SalesRecord[] = [];
  const salesData: { qty: string; desc: string; amt: string; }[] = [];
  const receiptData = ({
    name: '', address: '', phone: '', salesID: '', salesPerson: '', date: '', payment: '', customer: '', total: '', discount: '', totalPaid: ''
  })
  const [phone, setPhone] = useState('');
  const [discount, setDiscount] = useState('');
  const [date, setDate] = useState('');
  const [salesPerson, setSalesPerson] = useState('')
	
  const fetchStocks = async () => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `SELECT * FROM Sales_Record WHERE DATE(Date) = DATE('now', '+1 hour') ORDER BY ID DESC`,
        [],
        (_, results) => {
          const rows = results.rows;
          setTotalRows(rows.length)
          const salesArray: SalesRecord[] = [];
          for (let i = 0; i < rows.length; i++) {
            salesArray.push(rows.item(i) as SalesRecord);
          }
          setSales(salesArray);
					setFilteredResult(salesArray);
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  const CreateTables = async () => {
    DEBUG(true);
    enablePromise(true);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS Sales_Record (ID INTEGER PRIMARY KEY AUTOINCREMENT, " +
        "Customer_Name TEXT, Date DATETIME, Payment_Method TEXT, Total REAL);"
      );
  
      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS Sales_Items (ID INTEGER PRIMARY KEY AUTOINCREMENT, " +
        "Sales_ID INTEGER, Quantity INTEGER, Board TEXT, Customer TEXT, Payment_Method TEXT, Date DATETIME, Delivered TEXT, " + 
        "Notes Text, Item_Price REAL, Total REAL, FOREIGN KEY (Sales_ID) REFERENCES Sales_Record (ID)); "
      );
    });
  }
  

  useEffect(() => {
		if (stopCodes) {
			try {
        CreateTables()
				fetchStocks();
					console.log('Stocky')
			} catch (error) {
					console.log(error)
			}
			setTimeout (() => {
			},200)
		};
  }, [stopCodes]);
    
  useEffect(() => {
    if (stopCodes) {
      const filterChildViews = async () => {
        const filteredViews = await filterViews() as SalesRecord[];
        setFilteredResult(filteredViews);
      };
      filterChildViews();
    }
  }, [sales, searchText, stopCodes]);

  useEffect(() => {
    if (stopCodes) {
      timeout = setTimeout(() => {
        if (totalRows !== -1 && filteredResult.length === totalRows) {
          setShowLoadingIndicator(true)
        }
      }, 10000);
      if (totalRows !== -1 && filteredResult.length === totalRows) {
        clearTimeout(timeout)
        setTimeout(() => {
            setShowLoadingIndicator(false)
        }, 200);
      }
      let amt = 0
      {filteredResult.forEach((row) => {
        if (!isNaN(row.After_Discount) ){
        amt = amt + row.After_Discount
        } 
        })
      }
      setGrossTotal(amt.toString())

    }
  }, [totalRows, filteredResult, stopCodes]);

  const handleSearchTextChange = (value: string) => {
    setSearchText(value);
  };

  const filterViews = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const filteredViews = sales.filter((child) => {
          const hasTextMatch = (child.Customer_Name.toLowerCase() + (child.Payment_Method ? child.Payment_Method.toLowerCase() 
					: '')).includes(searchText.toLowerCase()) || (child.Sales_ID ? child.Sales_ID.toLowerCase() : '').includes(searchText.toLowerCase())
          const hasIdMatch = child.ID.toString().includes(searchText.toLowerCase());
          return hasTextMatch || hasIdMatch;
					
        });

        resolve(filteredViews);
      }, 0);
    });
  };

  const filterData = (query: string) => {
    const filteredResults = sales.filter((item) =>
      item.Customer_Name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredResult(filteredResults);
  };

  const deleteSelected = async (id: number) => {
    const updatedChildViews = sellItems.filter((item) => item.ID !== id);
    setSellItems(updatedChildViews);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `DELETE FROM Sales_Items WHERE ID = ?;`, [id],
        )
      })
  };

  const deleteFromSales = async (id: number) => {
    const updatedChildViews = sales.filter((item) => item.ID !== id);
    setSales(updatedChildViews);
    if (id.toString() === oneOnly) {
      setSellItems([])
      setOneOnly('')
      setValue('')
      setCustomerName('')
      setPhone('');
      setDiscount('');
      setTotalDue('');
    }
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `DELETE FROM Sales_Items WHERE Sales_ID = ?;`, [id],
        )
        tx.executeSql(
          `DELETE FROM Sales_Record WHERE ID = ?;`, [id],
        )
      })
   
  };

  const handlePreesed = ( data: SalesRecord) => {
		if (oneOnly === data.ID.toString()) {
			setOneOnly('')
      setSellItems([])
      setValue('')
      setCustomerName('')
      setSalesPerson('');
      setDate('')
      setSalesID('');
      setPhone('');
      setDiscount('');
      setTotalDue('');
		} else {
			setOneOnly(data.ID?.toString());
      setValue(data.Payment_Method);
      setCustomerName(data.Customer_Name);
      setSalesPerson(data.Sales_Person);
      setDate(data.Date)
      setSalesID(data.Sales_ID);
      showSalesRow(data.ID.toString());
      setDiscount(data.Discount?.toString());
      setPhone(data.Phone_Number);
      setTotalDue(data.Total.toString());
		}
	};

  const onToggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const reprintReceipt = async () => {
    salesData.splice(0, salesData.length);
    sellItems.forEach((row) => {
      salesData.push({qty: row.Quantity.toString(), desc: row.Board, amt: String(Number(row.Total).toLocaleString('en-NG', {}))})
    })
    
    DEBUG(true);
		enablePromise(true);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(`SELECT Company_Name, Address, CASE WHEN Phone_1 IS NOT NULL AND Phone_2 IS NOT NULL THEN Phone_1 || ', ' || Phone_2
        WHEN Phone_1 IS NOT NULL THEN Phone_1 WHEN Phone_2 IS NOT NULL THEN Phone_2 ELSE NULL END AS Phone FROM Company;`, [], (_, result) => {
        if (result.rows.length > 0) {
          receiptData.name = result.rows.item(0).Company_Name;
          receiptData.address = result.rows.item(0).Address
          console.log(result.rows.item(0))
          receiptData.phone = result.rows.item(0).Phone;
          const options: Intl.DateTimeFormatOptions = { hour:'numeric', minute:'numeric', year:'numeric', month:'long', day:'numeric' };
          receiptData.salesID = salesID;
          receiptData.salesPerson = salesPerson ? salesPerson : '';
          receiptData.date = new Date(date)?.toLocaleString('en-US', options);
          receiptData.payment = value;
          receiptData.customer = customerName;
          receiptData.total = String((Number(totalDue) + Number(discount)).toLocaleString('en-NG', {}));
          receiptData.discount = '-' + String(Number(discount).toLocaleString('en-NG', {}));
          receiptData.totalPaid = String((Number(totalDue)).toLocaleString('en-NG', {}))
          console.log(receiptData)
          createAndSavePDF(salesData, receiptData);
        } else {
          Alert.alert('Company Data not found', 'The company data is not found, it seems it has not yet been set.')
          return
        }
      })
    })
  };

  const showSalesRow = async (iD: string) => {
    const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
      tx.executeSql(
        'SELECT * FROM Sales_Items WHERE Sales_ID = ? ',
        [iD],
        (_, results) => {
          const rows = results.rows;
          const salesArray: SellList[] = [];
          for (let i = 0; i < rows.length; i++) {
            salesArray.push(rows.item(i) as SellList);
          }
          setSellItems(salesArray);
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
	};

  const searchDateSelected = async (start: string, end: string, month: string, monthName: string, year: string) => {
    if (end !== '00') {
      setFooterText(`Showing from ${getOrdinalSuffix(parseInt(start, 10))} to ${getOrdinalSuffix(parseInt(end, 10))} ${monthName}, ${year}`)
      setShowLoadingIndicator(true)
      setGrossTotal(' ')
      setCustomDate(true)
      DEBUG(true);
      enablePromise(true);
      const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `SELECT * FROM Sales_Record WHERE Date BETWEEN '${year}-${month}-${start} 00:00:00' AND '${year}-${month}-${end} 23:59:59' ORDER BY ID DESC`,
          [],
          (_, results) => {
            const rows = results.rows;
          setTotalRows(rows.length)
            for (let i = 0; i < rows.length; i++) {
              stocksArray.push(rows.item(i) as SalesRecord);
            }
            setSales(stocksArray);
            setFilteredResult(stocksArray);
          },
          (error) => {
            console.error('Error executing SQL', error);
          }
        );
      })
    }
  }

  const todayClicked = async () => {
    if (whoClicked !== 'today') {
      setFooterText('Showing from today')
      setWhoClicked('today')
      setShowLoadingIndicator(true)
      setGrossTotal(' ')
      setDateVisible(false)
      setCustomDate(false)
      DEBUG(true);
      enablePromise(true);
      const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `SELECT * FROM Sales_Record WHERE DATE(Date) = DATE('now', '+1 hour') ORDER BY ID DESC`,
          [],
          (_, results) => {
            const rows = results.rows;
          setTotalRows(rows.length)
            for (let i = 0; i < rows.length; i++) {
              stocksArray.push(rows.item(i) as SalesRecord);
            }
            setSales(stocksArray);
            setFilteredResult(stocksArray);
            const updatedCheckedItems: boolean[] = Array.from(
              { length: stocksArray.length },
              () => false
            );
                       
          },
          (error) => {
            console.error('Error executing SQL', error);
          }
        );
      })
    } 
  }

  const yesterdayClicked = async () => {
    if (whoClicked !== 'yesterday') {
      setFooterText('Showing from yesterday')
      setWhoClicked('yesterday')
      setShowLoadingIndicator(true)
      setGrossTotal(' ')
      setDateVisible(false)
      setCustomDate(false)
      DEBUG(true);
      enablePromise(true);
      const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `SELECT * FROM Sales_Record WHERE DATE(Date) = DATE('now', '-1 days', '+1 hour') ORDER BY ID DESC`,
          [],
          (_, results) => {
            const rows = results.rows;
          setTotalRows(rows.length)
            for (let i = 0; i < rows.length; i++) {
              stocksArray.push(rows.item(i) as SalesRecord);
            }
            setSales(stocksArray);
            setFilteredResult(stocksArray);
          },
          (error) => {
            console.error('Error executing SQL', error);
          }
        );
      })
    }
        
  }

  const customClicked = () => {
    setWhoClicked('custom')
    setDateVisible(true)
  };

  function getOrdinalSuffix(number: number): string {
    if (number >= 11 && number <= 13) {
      return number + 'th';
    } else {
      const lastDigit = number % 10;
      switch (lastDigit) {
        case 1:
          return number + 'st';
        case 2:
          return number + 'nd';
        case 3:
          return number + 'rd';
        default:
          return number + 'th';
      }
    }
  }
  
  const switchText = isSwitchOn ? 'Checkbox shown' : 'Checkbox hidden';
  const [value, setValue] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [handleChecked, setHandleChecked] = useState(true)

	return (
		<PaperProvider>
      <View style={{ flex: 1 }}>
      <View style={stylesBox.mainView}>
				<View style={stylesBox.searchMainContainer}>
					<View style={stylesBox.textInputMasterContainer}> 
						<TextInput
							mode="outlined"
							label={'Search record'}
							placeholder="Search"
							underlineColor={darkColour}
							activeOutlineColor={darkColour}
							spellCheck={false}
							contentStyle={stylesBox.searchTextInput} 
							style={{marginTop:-1, height:30 }}
							outlineStyle={{ borderWidth: 0, height:30, borderRightColor:'white', }}
							onChangeText={handleSearchTextChange}
						/>

						<View style={stylesBox.daySelect}>
							<MyButton btnText="Today"
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={2}
								btnColor={whoClicked === 'today' ? darkColour : 'white'}
								btnFontSize={15}
								btnHeight={32}
								btnWidth={95}
								btnTxtClr={whoClicked === 'today' ? 'white' : darkColour}
								btnPadding={4}
								hndClicked={todayClicked}
							/>
						</View>

						<View style={stylesBox.daySelect}>
							<MyButton 
								btnText="Yesterday" 
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={2}
								btnColor={whoClicked === 'yesterday' ? darkColour : 'white'}
								btnFontSize={15}
								btnHeight={32}
								btnWidth={95}
								btnTxtClr={whoClicked === 'yesterday' ? 'white' : darkColour}
								btnPadding={4}
								hndClicked={yesterdayClicked}
							/>
						</View>

						<View style={{...stylesBox.daySelect, width:110}}>
							<MyButton 
								btnText="Custom date" 
								btnBorClr={darkColour}
								btnBorRadius={10}
								btnBorWdt={2}
								btnColor={whoClicked === 'custom' ? darkColour : 'white'}
								btnFontSize={15}
								btnHeight={32}
								btnWidth={110}
								btnTxtClr={whoClicked === 'custom' ? 'white' : darkColour}
								btnPadding={4}
								hndClicked={customClicked}
							/>
						</View>
					</View>
				</View>
      </View>
        <View style={{flexDirection:'row'}}>
          <View style={stylesBox.stockViewBox}>
            <View style={stylesBox.stockViewHeader}>
              <View style={{ ...stylesBox.columnHeaderBox, marginLeft: 0, width:182, borderLeftWidth: 0 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Customer Name</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: 158 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Date & Time</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: 108 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Payment</Text>
              </View>
              <View style={{ ...stylesBox.columnHeaderBox, width: 100, borderRightWidth: 0 }}>
                <Text style={{ ...stylesBox.columnHeaderText }}>Total (₦)</Text>
              </View>
            </View>
            <View style={{flex:1, justifyContent: 'center', alignContent: 'center'}}>
              { showLoadingIndicator  ? (
              <ActivityIndicator size="large" color= {darkColour} />
                ) : (
                  <FlatList
                    data={filteredResult}
                    keyExtractor={(item) => item.ID.toString()}
                    renderItem={({ item, index }) => (
                      <ChildView
                        key={item.ID}
                        texts={[item.Customer_Name, item.Date, item.Payment_Method, 
                          item.After_Discount ? Number(item.After_Discount).toLocaleString('en-NG') : '0.00']}
                        isChecked={oneOnly === item.ID.toString() ? true : false}
                        onPressed={() => handlePreesed(item)}
                        index={index}
                        id={item.ID}
                        delPressed={() => deleteFromSales(item.ID)}
                      />
                    )}
                  />
                )
              }
            </View>
            
            <View style={stylesBox.footerMainContainer}>
					<View style={stylesBox.footerSub}>
						<View>
							<View style={{height: 40, flexDirection: 'row'}}>
								<View style={stylesBox.footerLeftContainer}>
									<Text style={{...stylesBox.columnHeaderText, color:'white', paddingTop:3}}>
										{footerText}
									</Text>
								</View>
							</View>
						</View>
				
				<View style={stylesBox.totalMainContainer}>
					<View style={stylesBox.totalContainer}>
            <Text style= {{...stylesBox.columnHeaderText, fontWeight:'900'}}>
              {Number(grossTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
            </Text>
					</View>
				</View>
			</View>
		</View>
          </View>
          
          <View style={{flexDirection:'column'}}>
            <View style={stylesBox.sellItemContainer}>
              <View style={stylesBox.sellItemHeader}>
                <View style={{ ...stylesBox.columnHeaderBox, marginLeft: 0, width: 59, borderLeftWidth: 0 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}>Qty</Text>
                </View>
                <View style={{ ...stylesBox.columnHeaderBox, width: 290 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}>Board Description</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width: 300}}>
                  <Text style={{...stylesBox.columnHeaderText}}>Notes</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:100}}>
                  <Text style={{...stylesBox.columnHeaderText}}>Amount (₦)</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:150 }}>
                  <Text style={{...stylesBox.columnHeaderText}}>Total Amount (₦)</Text>
                </View>
                <View style={{...stylesBox.columnHeaderBox, width:34 }}>
                <IconButton icon="send-check" iconColor='white' size={22} 
                  style={{width:40, height:35, marginTop: 0, padding:4}} 
                  containerColor={darkColour} focusable={false} />
                </View>
                <View style={{ ...stylesBox.columnHeaderBox, width: 36, borderRightWidth:0 }}>
                  <Text style={{ ...stylesBox.columnHeaderText }}></Text>
                </View>
              </View>

              <ScrollView>
                {sellItems.map((item, index) => (
                  <ToBeSold
                    key={item.ID}
                    texts={[item.Quantity.toString(), item.Board, item.Notes, 
                      item.Item_Price ? Number(item.Item_Price).toLocaleString('en-NG') : '0.00', 
                      item.Total ? Number(item.Total).toLocaleString('en-NG') : '0.00']}
                    index={index}
                    id={item.ID}
                    isChecked= {item.Delivered === 'Yes' ? true : false}
                    onCheckboxChange={(value)=> { setHandleChecked((prev) => !prev); value ? item.Delivered = 'Yes' : item.Delivered = 'No'; console.log(value, item.Delivered, item.Board)}}
                    delPressed={() => deleteSelected(item.ID)}
                  />
                ))}
              </ScrollView>
              
              <View style={{flexDirection:'column', borderWidth: 2, height: 78, borderColor: darkColour, margin: 10, borderRadius: 10, }}>
                <View style = {{flexDirection:'row'}}>
                  <View style={{...stylesBox.salesDetailsStyle, borderLeftWidth: 0, borderTopWidth: 0}}>
                    <Text style={{...stylesBox.mediumText, fontSize:16, color: darkColour}}>
                      Customer name: 
                    </Text>
                    <Text style={{...stylesBox.mediumText, fontSize:16, fontWeight:'800', color: darkColour}}>
                      {` ${customerName}`}
                    </Text>
                  </View>
                  <View style={{...stylesBox.salesDetailsStyle, borderRightWidth: 0, borderTopWidth: 0}}>
                    <Text style={{...stylesBox.mediumText, fontSize:16, color: darkColour}}>
                      Phone Number: 
                    </Text>
                    <Text style={{...stylesBox.mediumText, fontSize:16, fontWeight:'800', color: darkColour}}>
                      {` ${phone}`}
                    </Text>
                  </View>
                  
                </View>
                <View style = {{flexDirection:'row'}}>
                <View style={{...stylesBox.salesDetailsStyle, borderLeftWidth: 0, borderBottomWidth: 0}}>
                    <Text style={{...stylesBox.mediumText, fontSize:16, color: darkColour}}>
                      Payment Method: 
                    </Text>
                    <Text style={{...stylesBox.mediumText, fontSize:16, fontWeight:'800', color: darkColour}}>
                      {` ${value}`}
                    </Text>
                  </View>
                  <View style={{...stylesBox.salesDetailsStyle, borderRightWidth: 0, borderBottomWidth: 0}}>
                    <Text style={{...stylesBox.mediumText, fontSize:16, color: darkColour}}>
                      Discount: 
                    </Text>
                    <Text style={{...stylesBox.mediumText, fontSize:16, fontWeight:'600', color: darkColour}}>
                    {Number(discount).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                    </Text>
                  </View>
                  
                </View>
                
              
                {/* <View style={{flexDirection:'row'}}>
                  <Text style={{...stylesBox.mediumText, fontSize:17, color: darkColour, marginTop:0}}>
                    Payment method:
                  </Text>
                  <Text style={{...stylesBox.mediumText, fontSize:20, fontWeight:'800', color: darkColour, marginTop:-2}}>
                  {` ${value}`}
                  </Text>
                </View> */}
              </View>
              <View style={stylesBox.footerContainer}>
                <View style={stylesBox.footerSubContainer}>
                  <Text style={{...stylesBox.columnHeaderText, color:'white', marginTop:0}}>
                    Total amount paid
                  </Text>
                  <IconButton
                    icon="ray-start-arrow"
                    iconColor= 'white'
                    size={40}
                    focusable={false}
                    style={stylesBox.footerIconStyle}
                  />
                </View>
                <View style={stylesBox.totalContainer}>
                  <Text style= {{...stylesBox.columnHeaderText, fontWeight:'900'}}>
                  {Number(totalDue).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                  </Text>
                </View>
              </View>
            </View>
            {sellItems.length > 0 &&
            <View style = {{width: 960, alignItems:'center'}}>
              <View style={stylesBox.lastContainer}>
                <View style={{margin:10}}>
                  <MyButton btnText="Reprint receipt" btnColor={darkColour} hndClicked={reprintReceipt}/>
                </View>
              </View>
            </View>
            }
          </View>
          {dateVisible &&
          <View style={stylesBox.dateContainer}>
            <DateModule appearUp ={false} onNewDateSelected={searchDateSelected}/>
          </View> 
          }
        </View>
      </View>
		</PaperProvider>
	)
}

const stylesBox=StyleSheet.create ({
  purchasedTouchable: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: 'transparent',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
  viewStyle: {
		borderWidth: 2, 
		borderColor: 'black', 
		height: 35, 
		alignItems: 'center', 
		marginLeft: -2, 
		borderTopWidth: 0, 
		borderBottomWidth: 0,
	},
	textStyle: {
		color: darkColour,
		fontFamily: 'century gothic', 
		fontSize: 15, 
		fontWeight: 'normal',
		marginTop: 6,
	},
	childPressable: {
		flexDirection: 'row',
		alignItems: 'center',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
  iconButtonStyle: {
    justifyContent:'center', 
    padding:0, 
    margin:0, 
    marginLeft: -5, 
    alignContent:'center',
  },
  searchMainContainer: {
		flexDirection: 'column',
		backgroundColor: 'white',
		alignSelf: 'center',
		borderWidth: 2,
		borderColor: '#DCE3E8',
		borderRadius: 10,
		marginLeft: 10,
		marginTop: 10,
		marginBottom: 10,
		height: 40
	},
	columnHeaderText: {
	fontFamily:'century gothic', 
	fontSize:15, 
	fontWeight:'normal', 
	textAlign:'center',
	color:'white', 
	marginTop:6
	},
  searchContentStyle: {
    marginTop:-2, 
    marginLeft:-15,
		paddingTop: 2,
		paddingBottom: 0,
		borderWidth: 2,
		borderRightWidth: 0,
		borderRightColor: 'white',
		width: 380,
		height: 30,
		borderRadius: 10,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderColor: 'transparent',
	},
  modalChild: {
    width: 400, 
    height:200, 
    borderWidth:2, 
    borderRadius:10, 
    borderColor:darkColour, 
    backgroundColor:'white',
  },
  modalButtonContainer: {
    width:400, 
    flexDirection:'row-reverse', 
    paddingRight:20
  },
  stockViewBox: {
		width: 580,
		height: 600,
		borderWidth: 2,
		borderColor: '#DCE3E8',
		marginTop: 10,
		marginBottom: 0,
		borderRadius: 10,
		marginLeft: 20,
		marginRight: 20,
		backgroundColor: 'white',
	},
  sellItemContainer: {
    width:960,
    height: 600,
    borderWidth: 2,
    borderColor: '#DCE3E8',
    marginTop: 10,
    marginBottom: 0,
    borderRadius: 10,
    marginLeft: 0,
    marginRight: 20,
    backgroundColor: 'white',
  },
  sellItemHeader: {
    width: 957,
    height: 35,
    backgroundColor: darkColour,
    flexDirection: 'row',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
	stockViewHeader: {
		width: 577,
		height: 35,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
	mainView: {
		flexDirection: 'row', 
		backgroundColor: 'white', 
		borderWidth: 2, 
		borderRadius: 10, 
		marginLeft: 20, 
		marginRight: 20, 
		borderColor: '#DCE3E8',
	},
	firstSubView: {
		borderWidth: 2,
		borderRadius: 10,
		borderColor: '#DCE3E8',
		flexDirection: 'row',
		alignSelf: 'center',
		alignContent: 'center',
		width: 208,
		height: 40,
		margin: 20,
		marginTop: 0,
		marginBottom: 0
	},
	modalContainer: {
		marginLeft:600,
		marginTop: -50,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'white',
		flexDirection:'column-reverse', 
		width:400, 
		height:200, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  },
	notesText: {
    borderWidth: 1,
    borderRadius:10,
    borderColor: '#DCE3E8',
    width:360,
    height:80,
    padding:10,
    color:'black', 
    fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'300',
    marginBottom:10,
    marginHorizontal:0,
    alignSelf:'center'
  },

	columnHeaderBox: {
		borderWidth:2, 
		borderColor:'black', 
		width:57,  
		height:35, 
		alignItems:'center',
		marginLeft:-2,
		borderTopWidth:0,
	},
	
	mediumText: {
    color:'grey', 
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    marginTop:0,
    marginLeft: 10
	},
  totalContainer : {
    flexDirection:'row', 
    justifyContent:'center', 
    borderWidth:2, 
    marginRight: 76,
    borderLeftWidth:0, 
    borderRightWidth:0, 
    marginTop:0, 
    borderColor:'white', 
    width:152, 
    height:35, 
    alignSelf: 'center',
  },
  footerContainer : {
    flexDirection:'row', 
    alignSelf:'center', 
    height: 40, 
    backgroundColor: darkColour, 
    width: '100%',
    borderRadius: 10, 
    borderTopRightRadius: 0, 
    borderTopLeftRadius: 0, 
    alignContent: 'center',
  },
  footerSubContainer : {
    flexDirection:'row', 
    alignSelf:'flex-end', 
    flex: 1, 
    paddingHorizontal: 100, 
    height: 40, 
    justifyContent:'flex-end', 
    alignItems:'center',
  },
  footerIconStyle: {
    marginHorizontal:20, 
    margin: 0, 
    padding: 0, 
    alignSelf: 'center',
  },
  lastContainer : {
    flexDirection:'row', 
    borderRadius:10, 
    borderColor:'#DCE3E8', 
    borderWidth:2, 
    width: 220, 
    marginTop:10, 
    marginRight:20, 
    backgroundColor:'white',
  },
  daySelect: {
    alignSelf:'center', 
    marginLeft:-2, 
    height:40, 
    width:95,
    borderWidth:2, 
    borderColor: 'transparent', 
    borderTopRightRadius:10,
    borderBottomRightRadius:10, 
    marginRight:10, 
    borderLeftWidth:0, 
    marginTop:0, 
    alignContent:'center'
  },
  searchTextInput: {
    paddingTop: 2, 
    paddingBottom:0,
    borderWidth:2, 
    borderRightWidth:0,
    borderRightColor:'white',
    width: 300, 
    height:30, 
    borderRadius:10, 
    borderTopRightRadius:0,
    borderBottomRightRadius:0,
    borderColor: 'transparent',
  },
  deleteContainer: {
		flex:1, 
		backgroundColor:'white', 
		alignSelf:'center', 
		paddingRight:20
	},
  textInputMasterContainer: {
		flexDirection:'row', 
		width:634, 
		height:40
	},
  dateContainer: {
		marginTop:-60, 
		marginLeft:-190, 
		top:8, 
		left: 880, 
		position: 'absolute'
	},
  footerMainContainer: {
		height:40, 
		
		borderRadius:10, 
		borderTopRightRadius:0,
		borderTopLeftRadius:0,
		borderWidth:2, 
		borderTopWidth:0,
		borderColor:'#DCE3E8',
		backgroundColor: darkColour,
		alignItems:'center',
    width:'100%'
	},
	footerLeftContainer: {
		alignSelf:'flex-start', 
		alignItems: 'flex-start', 
		marginLeft:100, 
		height:28, 
		width:330
	},
	footerSub: {
		flexDirection:'row', 
		alignSelf:'center'
	},
	footerRightContainer: {
		flexDirection:'row', 
		height:54, 
		
		alignSelf:'flex-start', 
		justifyContent: 'flex-end',
	},
	totalMainContainer: {
		height: 40, 
		marginLeft:50,
    marginTop:1,
		alignItems:'center'
	},
  salesDetailsStyle: {
    flexDirection:'row', 
    flex: 1, 
    borderWidth: 2, 
    height: 40, 
    alignItems: 'center', 
    borderColor: darkColour, 
    marginLeft: -2, 
    marginTop: -2,
    borderTopLeftRadius: 0
  }
			
})

export default SalesPerCustomer;